const mutations = {
  SET_PROCESSING(state, value) {
    state.processing = value;
  },
  SET_SETTLEMENTS(state, value) {
    state.settlements = value;
  },
  SET_SHOW_SETTLEMENTS(state, value) {
    state.showSettlements = value;
  },
  SET_IMPORT_RESULT(state, value) {
    state.importResult = value;
  },
};

export default mutations;
